import {APIClient, useAuthContext, useClient} from '../context/auth-context';
import {useQuery} from 'react-query';
import {Employee} from '../context/company-context';

export function useStaffs() {
  const api = useClient();
  const {companyId} = useAuthContext();
  return useQuery<Employee[]>('staffs', () =>
    api.get(`staff/company/${companyId}/name`).then(d =>
      d.staffName.map(
        (s: {
          firstName: string;
          lastName: string;
          id: string;
          jobNo: string;
          onboardingDate: string;
        }) => ({
          id: s.id,
          name: `${s.lastName}${s.firstName}`,
          lastName: s.lastName,
          firstName: s.firstName,
          employeeNumber: s.jobNo,
          jobNo: s.jobNo,
          onBoardingDate: s.onboardingDate,
        }),
      ),
    ),
  );
}
